import { useMediaQuery } from "./useMediaQuery";

/**
 * The 900px switch is structural, not cosmetic: the desktop and mobile shells render different
 * trees (three zones vs a tinted band with a nav sheet), so it is resolved in JS rather than CSS.
 */
export const useIsMobile = (): boolean => useMediaQuery("(max-width: 899px)");

/**
 * The second structural switch of the system: below 1400px the Suivi rail stops being a column
 * and folds into a tab that opens a panel.
 */
/**
 * Under 1600px the context rail stops being a column and becomes a tray under the top bar, which
 * is a different tree, so it is resolved in JS like the other structural switches.
 */
export const useIsBelowDesk = (): boolean => useMediaQuery("(max-width: 1599px)");
